import React, {Component} from "react"
import PatientProfile from "./PatientProfile";
import { toast } from "react-toastify";
import key from "../../../config/key.json"
import { getFromStorage } from "../../../utils/storage";
import errorConfig from "../../../config/api.json"
import { Card, Button } from "react-bootstrap";
import { getToken, getNotifications } from "../saveToken";
import { connect } from "react-redux";
import { Edit } from "@material-ui/icons";
import ProfileDialog from "./ProfileDialog";

const color = "#229a88";

class Profile extends Component{
    state = {
        show: false
    }
    //Error Notification
    notifyError = error => {
        toast.error("" + error.toString());
    };

    //First function run when page load
    componentDidMount() {
        toast.dismiss();
        console.log(getFromStorage("data"))
        if (!getFromStorage(key.loginInfoKey)) {
            this.notifyError(errorConfig.notLoggedInError);
            this.props.history.push("/");
        } else if (getFromStorage(key.loginInfoKey).task === "authAdmin" || getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel") {
            this.props.history.push("/Graph")
        } else if (getFromStorage(key.loginInfoKey).task === "patient") {
            getNotifications(this.props.dispatch, this.props.notifications)
            getToken("patients")
        } else if (getFromStorage(key.loginInfoKey).task === "doctor") {
            getNotifications(this.props.dispatch, this.props.notifications)
            getToken("doctors")
        } else if (getFromStorage(key.loginInfoKey).task === "provider") {
            this.props.history.push("/provider_doctors")
        }
    }
    render(){
        if (getFromStorage(key.loginInfoKey).task === "patient") {
            return (
                <div style={{marginLeft: this.props.isOpened ? (window.innerWidth > 560 ? "160px" : "20px") : "20px", marginTop: "70px", marginRight: "20px"}}>
                    <Card style={{padding: "20px", fontSize: "14px"}} className="shadow-4">

                        <div>
                            <h3 style={{textAlign: "center", color, fontWeight: "bold"}}>Profile</h3>
                            <table>
                                <body>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Name:</td>
                                        <td>{getFromStorage("data").name}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Age:</td>
                                        <td>{getFromStorage("data").age}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Email:</td>
                                        <td>{getFromStorage("data").email}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Gender:</td>
                                        <td>{getFromStorage("data").gender === "M"? "Male" : "Female"}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Phone:</td>
                                        <td>{getFromStorage("data").phone}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Address:</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <br/>
                                            <Button size="sm" variant="success" style={{width: "auto"}} onClick={() => this.setState({show: true})}>
                                                <Edit fontSize="small" style={{fontSize: "16px"}}/>
                                                <span style={{marginLeft: "5px"}}>Edit Profile</span>
                                            </Button>
                                        </td>
                                    </tr>
                                </body>
                            </table>
                        </div>
                        <ProfileDialog show={this.state.show} handleClose={() => this.setState({show: false})} />
                    </Card>
                </div>
            )
        } else if (getFromStorage(key.loginInfoKey).task === "doctor") {
            return (
                <div style={{marginLeft: this.props.isOpened ? (window.innerWidth > 560 ? "160px" : "20px") : "20px", marginTop: "70px", marginRight: "20px"}}>
                    <Card style={{padding: "20px", fontSize: "14px"}} className="shadow-4">
                        <div>
                            <h3 style={{textAlign: "center", color, fontWeight: "bold"}}>Profile</h3>
                            <table>
                                <body>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Name:</td>
                                        <td>{getFromStorage("data").name}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Age:</td>
                                        <td>{getFromStorage("data").age}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Email:</td>
                                        <td>{getFromStorage("data").email}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Gender:</td>
                                        <td>{getFromStorage("data").gender === "M"? "Male" : "Female"}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Phone:</td>
                                        <td>{getFromStorage("data").phone}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Speciality:</td>
                                        <td>{getFromStorage("data").speciality}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Designation:</td>
                                        <td>{getFromStorage("data").designation}</td>
                                    </tr>
                                    <tr>
                                        <td style={{fontSize: "14px", color}}>Address:</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <br/>
                                            <Button size="sm" variant="success" style={{width: "auto"}} onClick={() => this.setState({show: true})}>
                                                <Edit fontSize="small" style={{fontSize: "16px"}}/>
                                                <span style={{marginLeft: "5px"}}>Edit Profile</span>
                                            </Button>
                                        </td>
                                    </tr>
                                </body>
                            </table>
                        </div>
                        <ProfileDialog show={this.state.show} handleClose={() => this.setState({show: false})} />
                    </Card>
                </div>
            )
        }
        return <div></div>
    }
}

export default connect(state => ({
    notifications: state.notifications
}))(Profile)